// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { thumbtack16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-thumbtack': IconThumbtack;
    }
}

/**
 * The icon component for the 'thumbtack' icon
 */
export class IconThumbtack extends Icon {
    public constructor() {
        super(thumbtack16X16);
    }
}

registerIcon('icon-thumbtack', IconThumbtack);
export const iconThumbtackTag = 'nimble-icon-thumbtack';
